//
import { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import withImmutablePropsToJS from "with-immutable-props-to-js"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"

import { alignmentTypeSearchConnection } from "shared/stakeholder/selectors"
import { getAlignmentTypes } from "shared/stakeholder/action-creators"
import { parseAndGenerateAlignmentTypeFilters } from "shared/search/components/FilterableListView/helperFunctions"
import {
    generateAlignmentTypeFilter,
    PriorityHasLabelFilter,
    PriorityLastUserFilter,
} from "shared/search/containers/Filter/Filters"
import { PRIORITY_FILTER_KEY } from "shared/imports/sharedConstants"
import { hasAnyPermission } from "shared/imports/permissionFunctions"

export const createStakeholderFilterGroup = (uniqueFilterGroupId) => {
    const actions = {
        getAlignmentTypes,
    }

    class StakeholderFilterGroup extends Component {
        render() {
            const hideAlignment = hasAnyPermission([DjangIO.app.models.PermissionType.hide_alignment])
            const hidePriority = hasAnyPermission([DjangIO.app.models.PermissionType.hide_priority])

            const filters = []

            if (!hideAlignment) {
                filters.push(
                    generateAlignmentTypeFilter({
                        alignmentTypes: this.props.alignmentTypes,
                        uniqueFilterId: "profileAlignmentType",
                        filterKey: "profile_alignment",
                    }),
                )
            }

            if (!hidePriority) {
                filters.push(PriorityHasLabelFilter, PriorityLastUserFilter)
            }

            return genericFilterGroup({
                uniqueFilterGroupId,
                filters,
                displayLabel: "Stakeholder",
                helpText: "Filter results by overall stakeholder alignment and priority.",
                ...this.props,
            })
        }
    }

    StakeholderFilterGroup.propTypes = {
        alignmentTypes: PropTypes.array.isRequired,
        // selected from the search => props.uniqueFlvId slice of the store
        searchFilterTerm: PropTypes.string,
        uniqueFilterGroupId: PropTypes.string.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
    }

    const connectedFilterGroup = connect(
        alignmentTypeSearchConnection,
        actions,
    )(withImmutablePropsToJS(StakeholderFilterGroup))

    Object.assign(connectedFilterGroup, {
        defaultProps: {
            filterKeyMap: {
                profileAlignmentType: "profile_alignment",
                legislativePriority: PRIORITY_FILTER_KEY,
                priorityLastUserFilter: "priority_last_user",
            },
            isConnectedFilterGroup: true,
            parseFunction: parseAndGenerateAlignmentTypeFilters,
            uniqueFilterGroupId,
        },
    })

    return connectedFilterGroup
}
